const BankLinksSVG = ({ classNames }: { classNames?: string }) => (
  <svg
    viewBox="0 0 110 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classNames}
  >
    <path
      d="m39.835 25.869 13.937 7.773c1.18.691 1.718.206 2.203-.007L70.76 25.33c.526-.327.888-.61.888-1.188s-.449-.87-.717-1.033l-3.98-2.602 3.784-2.15c.613-.3 1.266-.977 1.266-1.826v-5.724c0-1.489-.87-1.954-1.288-2.179L56.208.43c-1.256-.812-2.282-.276-2.706 0l-14.55 8.284c-.652.435-.86.901-.855 1.373.006.713.757 1.252.86 1.318l3.778 2.2L38.72 16c-.629.376-.673 1.075-.673 1.075-.046.313-.046 5.58-.046 5.58 0 1.383.129 2.284 1.835 3.214Zm29.187-1.613-14.166 7.766-13.693-7.557 4.295-2.413 8.888 4.976c.27.189.755.175 1.009.04l9.587-5.433 4.08 2.62Zm1.204-8.289L66.4 13.663l3.814-2.223.012 4.527ZM55.907 2.575l13.046 7.45-4.28 2.563L55.9 7.38l.008-4.805Zm-1.054 6.44 7.915 4.7-7.915 4.473h-.01l-8.092-4.577 8.092-4.597h.01Zm-14.337 1.067 13.306-7.524V7.38l-9.235 5.108-4.071-2.406Zm4.206 4.683 9.61 5.432a1.072 1.072 0 0 0 1.01.005l9.232-5.417 4.173 2.479-13.904 7.777-14.154-7.984 4.033-2.292Zm-4.846 4.102L43.6 20.95l-3.723 2.116v-4.198Z"
      fill="#000"
    />
    <circle cx="79.5" cy="17" r="2" fill="#D9D9D9" />
    <circle cx="2" cy="18" r="2" fill="#D9D9D9" />
    <circle cx="93.5" cy="17" r="2" fill="#D9D9D9" />
    <circle cx="16" cy="18" r="2" fill="#D9D9D9" />
    <circle cx="107.5" cy="17" r="2" fill="#D9D9D9" />
    <circle cx="30" cy="18" r="2" fill="#D9D9D9" />
  </svg>
);

export default BankLinksSVG;
